// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwTextarea from 'viewmodel/AwTextareaViewModel';
import AwButton from 'viewmodel/AwButtonViewModel';
import { ExistWhen } from 'js/hocCollection';
const TdExistWhen = ExistWhen('td');
TdExistWhen.displayName = 'TdExistWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/accHttpService', () => import('js/accHttpService'));
registerDynImportEntry('js/accEventBus', () => import('js/accEventBus'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "data": {
    "processRfqQuoteSideNavRightData": {
      "slide": "PUSH",
      "direction": "RIGHT_TO_LEFT",
      "animation": false,
      "width": "WIDE",
      "height": "FULL"
    },
    "comments": {
      "displayName": "Comments",
      "type": "STRING",
      "isRequired": "false",
      "isEditable": "true",
      "requiredText": "Please enter comments here",
      "numberOfLines": 5
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    },
    "rfqquoteid": {
      "type": "string"
    },
    "status": {
      "type": "string"
    }
  },
  "actions": {
    "processRfqQuote": {
      "actionType": "JSFunctionAsync",
      "method": "createHttpRequest",
      "inputData": {
        "request": {
          "method": "POST",
          "url": "/acc/orchestrate",
          "withCredentials": true,
          "data": {
            "appBaseUrl": "assets",
            "additionalProperties": {},
            "query": "mutation processRfqQuote( $collaborationspaceId: String, $rfqQuoteId: String, $status: String, $comments: String) { processRfqQuote( collaborationspaceId: $collaborationspaceId, rfqQuoteId: $rfqQuoteId, status: $status, comments: $comments) }",
            "variables": {
              "collaborationspaceId": "{{ctx.rfq.collaborationspaceid || props.collaborationspaceid}}",
              "rfqQuoteId": "{{ctx.rfq.rfqquoteid || props.rfqquoteid}}",
              "status": "{{ctx.rfq.status || props.status}}",
              "comments": "{{data.comments.dbValue}}"
            }
          }
        },
        "progressIndicatorPrefix": "collab",
        "accSessionId": "{{ctx.rfq.accsessionid || props.accsessionid}}"
      },
      "outputData": {
        "response": "data.data.processRfqQuote",
        "errorCode": "errorCode"
      },
      "events": {
        "success": [{
          "condition": "response.error === undefined",
          "name": "process-rfq-quote.success",
          "eventData": {
            "response": "{{response}}"
          }
        }, {
          "condition": "response.error === 'EMPTY_COLLAB_SPACE'",
          "name": "process-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.EMPTY_COLLAB_SPACE}}",
            "errorCode": 400
          }
        }, {
          "condition": "response.error.statusCode === 400 || errorCode === 400",
          "name": "process-rfq-quote.error",
          "eventData": {
            "error": "{{response.error}}"
          }
        }, {
          "condition": "response.error.statusCode === 403 || errorCode === 403",
          "name": "process-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.FORBIDDEN}}",
            "errorCode": 403
          }
        }, {
          "condition": "response.error.statusCode === 401 || errorCode === 401 || errorCode === 'INVALID_ACC_SESSION_ID'",
          "name": "process-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.UNAUTHORIZED}}",
            "errorCode": 401
          }
        }, {
          "condition": "response.error.statusCode >= 500 && response.error.statusCode <= 599",
          "name": "process-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }],
        "failure": [{
          "name": "process-rfq-quote.error",
          "eventData": {
            "error": "{{i18n.ACC_SERVER_ERROR}}",
            "errorCode": 500
          }
        }]
      },
      "deps": "js/accHttpService"
    },
    "publishToACCEventBus": {
      "actionType": "JSFunction",
      "method": "publish",
      "inputData": {
        "eventId": "{{parameters.eventId}}",
        "eventData": "{{parameters.eventData}}"
      },
      "deps": "js/accEventBus"
    }
  },
  "onEvent": [{
    "eventId": "process-rfq-quote.success",
    "message": "ProcessRfqQuoteSuccess"
  }, {
    "eventId": "process-rfq-quote.success",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-process-rfq-quote.success",
      "eventData": "{{eventData.response}}"
    }
  }, {
    "eventId": "process-rfq-quote.error",
    "message": "ProcessRfqQuoteError"
  }, {
    "eventId": "process-rfq-quote.error",
    "action": "publishToACCEventBus",
    "inputArgs": {
      "eventId": "des-process-rfq-quote.error",
      "eventData": {
        "message": "{{eventData.error}}",
        "statusCode": "{{eventData.errorCode}}"
      }
    }
  }],
  "conditions": {},
  "messages": {
    "ProcessRfqQuoteSuccess": {
      "messageType": "INFO",
      "messageText": "RFQ Quote got processed successfully."
    },
    "ProcessRfqQuoteError": {
      "messageType": "WARNING",
      "messageText": "Error in Process RFQ Quote"
    }
  },
  "i18n": {
    "acknowledge": ["RfqMessages"],
    "noQuote": ["RfqMessages"],
    "ACC_SERVER_ERROR": ["errorMessages"],
    "EMPTY_COLLAB_SPACE": ["errorMessages"],
    "FORBIDDEN": ["errorMessages"],
    "UNAUTHORIZED": ["errorMessages"]
  },
  "_viewModelId": "ProcessRfqQuote",
  "_uniqueViewModelId": "ProcessRfqQuote",
  "ctx": {
    "rfq": {
      "type": "object"
    }
  }
};

/*
<div class="afx-content-background aw-layout-full sw-column">
    <table>
        <tr class="tableBody">
            <td>
                <aw-textarea prop="data.comments"></aw-textarea>
            </td>
            </tr>
            <tr clas="tableFooter">
                <td exist-when="props.status === 'Acknowledged'">
                    <aw-button action="processRfqQuote" size="auto">{{i18n.acknowledge}}</aw-button>
                </td>
                <td exist-when="props.status === 'No Quote'">
                    <aw-button action="processRfqQuote" size="auto">{{i18n.noQuote}}</aw-button>
                </td>
            </tr>
    </table>
</div>

*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement("div", {
    className: "afx-content-background aw-layout-full sw-column"
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", {
    className: "tableBody"
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(AwTextarea, getField("data.comments", fields, $index, null, null)))), /*#__PURE__*/React.createElement("tr", {
    clas: "tableFooter"
  }, /*#__PURE__*/React.createElement(TdExistWhen, {
    existWhen: AwParseService.instance("props.status === 'Acknowledged'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwButton, {
    action: actions.processRfqQuote,
    size: "auto"
  }, AwParseService.instance("i18n.acknowledge")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  }))), /*#__PURE__*/React.createElement(TdExistWhen, {
    existWhen: AwParseService.instance("props.status === 'No Quote'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }, /*#__PURE__*/React.createElement(AwButton, {
    action: actions.processRfqQuote,
    size: "auto"
  }, AwParseService.instance("i18n.noQuote")({
    props,
    data,
    fields,
    dataProviders,
    ctx,
    i18n,
    actions,
    subPanelContext,
    viewPath,
    conditions,
    formProp,
    dispatch,
    selectionModels,
    editHandlers,
    chartProviders,
    ports
  })))))));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;